/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Toast_ErrorInputs */



/**
* | output |
* | --- |
* | "Your message could not be sent. Please try again in a moment." |
*
* @param {Support_Toast_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const support_toast_error = /** @type {((inputs?: Support_Toast_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Toast_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Deine Nachricht konnte nicht gesendet werden. Bitte versuche es in einem Moment erneut.")
	return /** @type {LocalizedString} */ ("Your message could not be sent. Please try again in a moment.")
});